import type { ReactNode } from 'react';
import ScrollToTop from './ScrollToTop';
import Navbar from './Navbar';
import Footer from './Footer';

interface LayoutProps {
  children: ReactNode;
  // 页面主体是否需要顶部留白（非首页无透明导航时）
  withPadding?: boolean;
}

export default function Layout({ children, withPadding = true }: LayoutProps) {
  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <ScrollToTop />
      <Navbar />
      <main className="flex-1">{withPadding ? <div className="pt-16">{children}</div> : children}</main>
      <Footer />
    </div>
  );
}